// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xLfg","placeholdersHeader":"styles_placeholdersHeader__SNv5i","editorStyle":"styles_editorStyle__ryEFi","placeholdersBox":"styles_placeholdersBox__1mVh3"};